import * as React from "react";

import {
  GridApiContext,
} from "@mui/x-data-grid";

import AddCircleIcon from '@mui/icons-material/AddCircle';

import { IconButton, Tooltip } from "@mui/material";

import GetAppIcon from '@mui/icons-material/GetApp';

import { makeStyles } from "@mui/styles";


const useStyles = makeStyles(
  {
    root : {
      height: '35px',
      display: 'flex',
      justifyContent: 'space-between'
    },
    left : {
      lineHeight: '35px',
      marginLeft: '10px'
    },
    right: {
      textAlign: "right",
      marginRight: '15px',
      '& .MuiButtonBase-root': {
        padding: '5px !important'
      }
    }

  }
);

export default function Toolbar({
  addIconLabel,
  downloadLabel,
  handleDownloadGrid,
  handleAdd,
  rows,
  isAddIconDisabled = false,
  handleNoRowDownloadDisabled = false,
  defaultValuesForNewRecord = {},
  leftContent,
  editRowsModel
}) {
  const classes = useStyles();
  const apiRef = React.useContext(GridApiContext);

  const handleAddNewRecord = () => {
    if(handleAdd){
      handleAdd();
      return;
    }
    let editExists = false;
    // Check if there are any rows currently in edit mode
    if (editRowsModel && Object.keys(editRowsModel).length > 0) {
      editExists = true;
    }
    if (editExists) {
      return false;
    }

    const id = 'editNewRecord-' + Math.floor(Math.random() * 10);
    apiRef.current.updateRows([{ id, isNew: true, isNewRecord: true, is_active: "False", ...defaultValuesForNewRecord }]);
    
    // Use startRowEditMode instead of setRowMode for MUI DataGrid v6
    if (apiRef.current.startRowEditMode) {
      apiRef.current.startRowEditMode({ id });
    }

    setTimeout(() => {
      // eslint-disable-next-line 
      if (apiRef && apiRef.current && apiRef.current.scrollToIndexes){
          apiRef.current.scrollToIndexes({
        rowIndex: 0
      })
      }
  }, 150);
  }

  let isDownloadButtonDisabled = false;
  if (handleNoRowDownloadDisabled && rows.length === 0) {
    isDownloadButtonDisabled = true;
  }
  return (
    <div className={classes.root}>
    <div className={classes.left}>
      {leftContent && leftContent()}
    </div>
    <div className={classes.right} >
      {addIconLabel && (<Tooltip title={addIconLabel}>
        <span>
          <IconButton
            disabled={isAddIconDisabled}
            onClick={handleAddNewRecord}
            aria-label="add">
            <AddCircleIcon />
          </IconButton>
        </span>
      </Tooltip>)}
      {downloadLabel && (
        <Tooltip title={downloadLabel}>
          <span>
            <IconButton
              disabled={isDownloadButtonDisabled}
              onClick={() => {
                handleDownloadGrid(rows)
              }}
              aria-label="download"
              data-testid={"download"}
            >
              <GetAppIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </div>
    </div>
  );
}
